import type { FC, ReactNode } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import type { ITheme } from '@homeviews/styles'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      borderRadius: 5,
      padding: theme.spacing(1),
      backgroundColor: theme.colors.white,
      border: 'solid 1px #000433',
      '& .l-chartLabelItem': {
        display: 'flex',
        alignItems: 'center',
        marginRight: 19,
        marginTop: 10,
        '& p': {
          fontSize: 12,
          fontWeight: 400,
          letterSpacing: '-0.11px',
          lineHeight: '15px',
          margin: 0,
          color: `#000433 !important`,
        },
      },
      '& .l-chartLabelItem__shape': {
        width: 12,
        height: 12,
        borderRadius: '50%',
        borderWidth: 2,
        borderStyle: 'solid',
        marginRight: 5,
      },
    },
  }),
)

interface IProps {
  children: ReactNode
}

const ChartTooltip: FC<IProps> = (props) => {
  const classes = useStyles()

  return <div className={classes.root}>{props.children}</div>
}

export default ChartTooltip
